import request from '@/utils/request'

export default {
    getRequests: async({ commit }, params) => {
        commit('SET_LOAD', true)

        await request({
            method: 'get',
            url: '/moderation/requests',
            params: {
                ...Object.select(params, ['status', 'page', 'column', 'direction', 'type', 'email'])
            }
        }).then(res => {
            if (res.data && res.data.items) {
                commit('SET_PAGINATION', {
                    length: res.data.totalPages,
                    page: res.data.page,
                    total: res.data.total
                })
                commit('SET_REQUESTS', res.data.items.map(it => ({ ...it, oldStatus: it.status })))
            }
        }).finally(() => {
            commit('SET_LOAD', false)
        })
    },

    changeStatus: async({ dispatch, commit }, data) => {
        return await request({ method: 'patch', url: `/moderation/${data.id}/status`, data: {
            status: data.status
        }}).then(res => res.status == 200)
            .catch(_ => null)
    },

    getResetAccountFeeDate: async({ commit }, data) => {
        await request({
            method: 'get',
            url: '/account/resets/fee'
        })
            .then(res => {
                if (res.data) {
                    commit('SET_RESET_ACCOUNT_FEE_DATE', res.data)
                }
            })
            .catch(_ => null)
    },

    changeResetAccountFeeDate: async({ commit, dispatch }, data) => {
        return await request({
            method: 'put',
            url: '/account/resets/fee',
            data
        })
            .then(res => {
                if (res.status == 204) {
                    dispatch('addMessage', {
                        type: 'success',
                        message: 'updated',
                        locale: true
                    }, { root: true })
                    return res.status == 204
                }
            })
            .catch(err => {
                console.error(err)
            })
    },

    deleteResetAccountFeeDate: async({ commit, dispatch }, data) => {
        return await request({
            method: 'delete',
            url: '/account/resets/fee',
            data
        })
            .then(res => {
                if (res.status == 204) {
                    dispatch('addMessage', {
                        type: 'success',
                        message: 'success',
                        locale: true
                    }, { root: true })
                    return res.status == 204
                }
            })
            .catch(err => {
                console.error(err)
            })
    }
}
